import React from "react";

import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import Button from "@material-ui/core/Button";

// @material-ui/icons

// core components
import Header from "./Sections/Header.jsx";
import Footer from "./Sections/Footer.jsx";
import GridContainer from "./Sections/GridContainer.jsx";
import GridItem from "./Sections/GridItem.jsx";
//import Button from "./Sections/Button.js";
//import Parallax from "./Sections/Parallax.js";

import styles from "./Sections/styles/landingPage.jsx";

// Sections for this page
// import TimeLine from "./Sections/timeline";
import TimeLine from "./Sections/TimeLine.jsx";

import lesson_zh from "../languages/Contents_zh.js";
//import { renderers } from "react-markdown";

import { langAbbr } from "../langConfig";

const useStyles = makeStyles(styles);

const isNumber = require("is-number");

function getNumber(number) {
  if (isNumber(number)) return parseInt(number);
  return 0;
}

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  var lessons = lesson_zh;

  // 语言参数接收
  const queryString = require("query-string");
  var parsed = queryString.parse(props.location.search);
  localStorage.setItem("lang", 1);
  if (parsed.lang !== undefined) {
    let lindex = langAbbr.indexOf(parsed.lang);
    if (lindex === 0 || lindex === -1 || lindex >= langAbbr.length) {
      localStorage.setItem("lang", 0);
    } else {
      localStorage.setItem("lang", lindex);
    }
  } else {
    if (localStorage.getItem === undefined) localStorage.setItem("lang", 0);
  }

  switch (localStorage.getItem("lang")) {
    case "0":
      lessons = lesson_zh;
      break;
    default:
      let lessonsmodule = require("../languages/Contents_" +
        langAbbr[getNumber(localStorage.getItem("lang"))] +
        ".js");
      lessons = lessonsmodule.default;
      break;
  }

  return (
    <div className={classes.mainpage}>
      <Header
        color="transparent"
        fixed
        changeColorOnScroll={{
          height: 200,
          color: "dark",
        }}
        {...rest}
      />

      <div className={classes.titlecontainer}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6} className={classes.bannerIntro}>
            <h1 className={classes.title}>{lessons[0].info.name}</h1>
            <h4 className={classes.subtitle}>{lessons[0].info.subname[0]}</h4>
            <h4>
              {lessons[0].info.subname[1]}&nbsp;&nbsp;
              <a
                style={{ color: "#ac6aef" }}
                target="_blank"
                href={process.env.REACT_APP_WEB}
              >
                [{lessons[0].local.detail}]
              </a>
            </h4>
            <h4>
              {lessons[0].info.learninide[0]}{" "}
              {/* <a
                href={process.env.REACT_APP_WEB}
                style={{ color: "#ac6aef" }}
                target="_blank"
              >
                [{lessons[0].info.learninide[1]}]
              </a> */}
            </h4>
            <br />

            <div>
              <Link to="/lesson/1/chapter/1" style={{ color: "#ac6aef" }}>
                <Button
                  variant="outlined"
                  color="inherit"
                  classes={{
                    root: classes.mybutton,
                  }}
                >
                  {lessons[0].info.practice}
                </Button>
              </Link>

              <a href={process.env.REACT_APP_WEB} target="_blank">
                <Button
                  variant="outlined"
                  color="inherit"
                  classes={{
                    root: classes.mybuttonr,
                  }}
                >
                  {lessons[0].info.learnmore}
                </Button>
              </a>
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <img
              src={require("../../static/images/catalog/castle.jpg")}
              className={classes.bannerImage}
              alt="bannerimage"
            ></img>
          </GridItem>
        </GridContainer>
      </div>

      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <TimeLine chapterList={lessons} />
        </div>
      </div>

      <Footer />
    </div>
  );
}
